
import React from 'react'

function HomePage () {
  return (
    <div className='homepage1' >
      <video src='videos/Dating_Intro_3.mp4' autoPlay loop muted />
    </div>
  )
}

export default HomePage



// WEBPACK FOOTER //
// ./src/components/HomePage/homePage.js